
































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { DataOptions, DataTableHeader } from "vuetify";
import {
  LocationModel,
  LocationsApi,
  MailModel,
  MailsApi,
} from "../../../apis";
import { IAction } from "../common/CommonTypes";
import MoreVertBtn from "../common/MoreVertBtn.vue";
import ConfirmDialog from "../user-management/ConfirmDialog.vue";
import { ACTION } from "./";
import AddEditEmailDialog from "./AddEditEmailDialog.vue";
import { Dictionary } from "lodash";

@Component({
  components: { AddEditEmailDialog, MoreVertBtn, ConfirmDialog },
})
export default class MailList extends Vue {
  showAddEditEmailDialog = false;
  showDeleteEmailDialog = false;
  keywords = "";
  type = "";
  //
  mode: ACTION = null;
  locationDetailResponse: LocationModel = null;
  dataMailList: MailModel[] = [];
  selectedMail: MailModel | { [k: string]: any } = null;
  pagingOption: DataOptions | null = null;
  totalItems = 0;
  //
  get actions(): Array<IAction> {
    return [
      {
        titleName: this.$t("text.edit"),
        action: ACTION.EDIT_EMAIL,
        permission: { context: "MAILING_LIST_MANAGEMENT", action: "update" },
      },
      {
        titleName: this.$t("text.delete"),
        action: ACTION.DELETE_EMAIL,
        titleStyle: "color: red",
        permission: { context: "MAILING_LIST_MANAGEMENT", action: "delete" },
      },
    ];
  }
  get TYPES() {
    return [
      { text: this.$t("text.mailAlarm1"), value: "TREATMENT" },
      { text: this.$t("text.mailAlarm2"), value: "REACHED" },
      { text: this.$t("text.mailAlarm3"), value: "ALARM" },
    ];
  }

  get HEADERS() {
    return [
      {
        text: this.$t("text.emailAddress"),
        value: "emailAddress",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.notificationType"),
        value: "notificationType",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
        sortable: false,
      },
      {
        text: this.$t("text.createdDate"),
        value: "createdAt",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.action"),
        value: "action",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
        sortable: false,
      },
    ] as DataTableHeader[];
  }

  async created() {
    const rs = await new LocationsApi().getLocationById({
      id: this.$route.params.id,
    });
    this.locationDetailResponse = rs.data.data;
  }

  get ROW_PER_PAGES() {
    return this.$util.getConfig().settings.rowPerPage;
  }

  get addEmailClick() {
    return this.$store.getters.addEmailClick;
  }

  onSearch() {
    this.doSearch();
  }

  @Watch("addEmailClick")
  onAddEmailClickWatch() {
    this.mode = ACTION.NEW_EMAIL;
    this.showAddEditEmailDialog = true;
    this.selectedMail = { emailAddress: "" };
  }

  checkStatusAction() {
    return this.actions.filter((val) => val.action);
  }

  async onSelectedAction(item, action) {
    this.selectedMail = { ...item };
    switch (action) {
      case ACTION.EDIT_EMAIL: {
        this.mode = ACTION.EDIT_EMAIL;
        this.showAddEditEmailDialog = true;
        break;
      }
      case ACTION.DELETE_EMAIL: {
        this.showDeleteEmailDialog = true;
        break;
      }
      default: {
        break;
      }
    }
  }

  async onOkConfirmDeleteEmailDialog() {
    this.$util.showLoading();
    try {
      await new MailsApi().deleteMail({
        id: this.selectedMail.id,
      });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
    this.doSearch();
    this.showDeleteEmailDialog = false;
  }

  onPagingOption() {
    this.doSearch();
  }

  async doSearch() {
    this.$util.showLoading();
    try {
      const rs = await new MailsApi().getMailsByKeyword({
        keyword: this.keywords,
        notificationType: this.type || "",
        locationId: this.$route.params.id,
        page: this.pagingOption.page,
        limit: this.pagingOption.itemsPerPage,
        orderBy: this.pagingOption.sortBy[0] || "",
        orderDesc: this.pagingOption.sortDesc[0]
          ? this.pagingOption.sortDesc[0].toString()
          : "",
      });
      this.dataMailList = rs.data.data;
      this.totalItems = rs.data.count;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }
}
